import React from 'react';
import { observer } from 'mobx-react';

// Translation
import translate from '../../translate/Translate';

const InstructorHome = observer(
  class InstructorHome extends React.Component {
    render() {
      const { allCompleted, history, incomplete, store, translation } = this.props;
      const { AppStore, UserStore } = store;
      const { assessmentGroupSid, targetUserData } = UserStore;

      if (!AppStore.loading && assessmentGroupSid && allCompleted) {
        // All of the target user’s assessments have been completed
        // so redirect to the report.
        setTimeout(() => {
          history.push('/report/intro');
        })
        return null;
      } else if(!AppStore.loading) {
        return (
          <main
            id="main-content"
            className="page"
            tabIndex="-1"
            aria-labelledby="page-title"
          >
            <div className="panel panel--sm panel--solo panel--solo-alt">
              <h1 id="page-title" className="panel__title">
                {translation.incomplete.heading}
              </h1>

              <p>{translation.incomplete.body.replace('%student%', `${targetUserData.firstName || 'Student'} ${targetUserData.lastName || ''}`)}</p>

              
              {incomplete?.length > 0 &&
                <section aria-labelledby="incomplete-list">
                  <h2 className='meta' id='incomplete-list'>List of PLG Not completed</h2>
                  <ul className="data data--alt">
                    {incomplete.map((assessment, i) =>
                      <li key={i}>{assessment.name}</li>
                    )}
                  </ul>
                </section>
              }
            </div>
          </main>
        );
      }

      return null;
    }
  }
);

export default translate('InstructorHome')(InstructorHome);
